<template>
    <div>
        <v-container grid-list-md fluid text-xs-center>
            <v-layout row wrap>
                <v-flex xs12 md6>
                    <v-card style="height: 100%">
                        <v-card-title class="display-1">
                            {{$t('contactUs') | capitalize}}
                        </v-card-title>
                        <v-card-text>
                            <div v-if="$utils.isMobile()" class="contact-table">
                                <div >
                                    <v-icon class="mr-1">phone</v-icon>
                                    {{$t('hotline') | capitalize}}
                                </div>
                                <div>1900 638 399</div>
                                <div class="mt-3">
                                    <v-icon class="mr-1">email</v-icon>
                                    {{$t('email') | capitalize}}
                                </div>
                                <div>support@fpt.ai</div>
                                <div class="mt-3">
                                    <v-icon class="mr-1">location_on</v-icon>
                                    {{$t('address') | capitalize}}
                                </div>
                                <div>
                                    {{$t('fptBuildingAddress')}}
                                </div>
                                <div>
                                    <v-btn @click="goToGoogleMap">
                                        <v-icon class="mr-1">mdi-google-maps</v-icon>
                                        {{$t('map')}}
                                    </v-btn>
                                </div>
                            </div>
                            <table v-else class="contact-table">
                                <tr>
                                    <td>
                                        <v-icon class="mr-1">phone</v-icon>
                                        {{$t('hotline') | capitalize}}
                                    </td>
                                    <td>1900 638 399</td>
                                </tr>
                                <tr>
                                    <td>
                                        <v-icon class="mr-1">email</v-icon>
                                        {{$t('email') | capitalize}}
                                    </td>
                                    <td>support@fpt.ai</td>
                                </tr>
                                <tr>
                                    <td>
                                        <v-icon class="mr-1">location_on</v-icon>
                                        {{$t('address') | capitalize}}
                                    </td>
                                    <td>
                                        {{$t('fptBuildingAddress')}} <br>
                                        <v-btn @click="goToGoogleMap">
                                            <v-icon class="mr-1">mdi-google-maps</v-icon>
                                            {{$t('map')}}
                                        </v-btn>
                                    </td>
                                </tr>
                            </table>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex xs12 md6>
                    <v-card>
                        <v-card-title class="display-1">
                            {{$t('dropUsALine') | capitalize}}
                        </v-card-title>
                        <v-card-text>
                            <v-form v-model="formValid" @submit.prevent="submit" ref="form">
                                <v-text-field
                                    :label="$filters.capitalize($t('name'))"
                                    v-model='model.name'
                                    :rules="formRules.required"
                                    required
                                ></v-text-field>
                                <v-text-field
                                    :label="$filters.capitalize($t('phoneNumber'))"
                                    v-model='model.phone'
                                    :rules="formRules.phone"
                                ></v-text-field>
                                <v-text-field
                                    :label="$filters.capitalize($t('email'))"
                                    v-model='model.email'
                                    :rules="formRules.email"
                                    required
                                ></v-text-field>
                                <v-textarea
                                    :label="$filters.capitalize($t('message'))"
                                    v-model='model.message'
                                    :rules="formRules.required"
                                    required
                                ></v-textarea>
                                <v-layout justify-end>
                                    <v-btn color="primary" type='submit'>{{$t('sendMessage')}}</v-btn>
                                </v-layout>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import FormMixin from '@/modules/fptai/mixins/FormMixin'

export default {
    name: 'ContactUs',
    mixins: [FormMixin],
    data () {
        return {
            position: {
                lat: 21.0313471,
                lng: 105.7820749
            },
            infoWinOpen: true,
            infoOptions: {
                pixelOffset: {
                    width: -12,
                    height: -45
                }
            },
            formValid: false,
            model: {
                name: '',
                phone: '',
                email: '',
                message: ''
            }
        }
    },
    created () {
        this.$store.dispatch(this.$actionTypes.LOADING, false)
    },
    methods: {
        submit () {
            if (this.formValid) {
                this.$http.post('contactus/', this.model).then(
                    result => {
                        if (result.data.success) {
                            this.$appService.toastSuccess(this.$t('contactUsPage.success'))
                            this.$refs.form.reset()
                        } else {
                            this.$appService.toastError(this.$t('contactUsPage.fail'))
                        }
                    },
                    () => this.$appService.toastError(this.$t('contactUsPage.fail'))
                )
            } else {
                this.$refs.form.validate()
            }
        },
        goToGoogleMap () {
            window.open(
                'https://www.google.com/maps/place/FPT+Building+C%E1%BA%A7u+Gi%E1%BA%A5y/' +
                '@21.030752,105.7805796,17z/' +
                'data=!3m1!4b1!4m5!3m4!1s0x313454b355336d23:0xb337376aa7a9622f!8m2!3d21.030747!4d105.7827683'
            )
        }
    }
}
</script>
<style scoped lang="scss">
    .contact-table {
        text-align: left;

        tr:not(:first-child) td {
            padding-top: 15px;
        }

        tr td {
            padding-right: 15px;
            vertical-align: baseline;

            &:first-child {
                white-space: nowrap;
            }
        }
    }
</style>
